import styled from 'styled-components';
import { style, ResponsiveValue } from 'styled-system';
import { Flex } from '../primitives';
import { colors, ColorType } from '../../theme/colors';

export const SeparatorBaseContainer = styled(Flex)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

SeparatorBaseContainer.displayName = 'SeparatorBaseContainer';

export const SeparatorLineBase = styled.div<{ separatorColor?: ResponsiveValue<string> }>`
  flex: 1;
  border-top: 2px dotted;
  ${style({
    prop: 'separatorColor',
    cssProperty: 'border-color',
    transformValue: (color) => colors[color as ColorType],
  })};
`;

SeparatorLineBase.displayName = 'SeparatorLineBase';
SeparatorLineBase.defaultProps = {
  separatorColor: 'swirl',
};
